import React from 'react';
import {Message} from 'rsuite';


export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        })
    }

    render() {
        if (this.state.hasError)
            return <Message type="error" description="Error" />;

        return this.props.children;
    }
}